import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class CreateInvestorGoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CreateInvestorGoalError', ...args);
    }
}
export default CreateInvestorGoalError;
